<div class="container">
  @for (section of candidates | keyvalue; track section) {
    <div>
      <jmkw-disambiguation-section
        [section]="section.key"
        [candidates]="section.value"
        (selection)="select($event)"
      ></jmkw-disambiguation-section>
    </div>
  }
</div>
